/**
 * Updates Google Tag Manager Consent Mode v2 signals
 * Call this whenever user changes cookie preferences
 */
export const updateGTMConsent = (consent: {
  functionalCookiesAllowed: boolean;
  performanceCookiesAllowed: boolean;
}): void => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    console.warn('[GTM] gtag function not available');

    return;
  }

  const consentUpdate: {
    analytics_storage: 'granted' | 'denied';
    ad_storage: 'granted' | 'denied';
    ad_user_data: 'granted' | 'denied';
    ad_personalization: 'granted' | 'denied';
  } = {
    analytics_storage: consent.functionalCookiesAllowed ? 'granted' : 'denied',
    ad_storage: consent.performanceCookiesAllowed ? 'granted' : 'denied',
    ad_user_data: consent.performanceCookiesAllowed ? 'granted' : 'denied',
    ad_personalization: consent.performanceCookiesAllowed ? 'granted' : 'denied',
  };

  // Update GTM consent state
  window.gtag('consent', 'update', consentUpdate);

  window.dataLayer.push({
    event: 'consent_updated',
    consent_analytics: consent.functionalCookiesAllowed,
    consent_marketing: consent.performanceCookiesAllowed,
    timestamp: new Date().toISOString(),
  });

  console.log('[GTM] Consent updated:', consentUpdate);
};

/**
 * Gets current consent state from localStorage
 */
export const getStoredConsent = (): {
  functionalCookiesAllowed: boolean;
  performanceCookiesAllowed: boolean;
} | null => {
  try {
    const consentData = localStorage.getItem('Betzone.consent');

    if (!consentData) return null;

    const parsed = JSON.parse(consentData);
    const consent = parsed.value?.consent;

    if (!consent) return null;

    return {
      functionalCookiesAllowed: Boolean(consent.functionalCookiesAllowed),
      performanceCookiesAllowed: Boolean(consent.performanceCookiesAllowed),
    };
  } catch (e) {
    console.error('[GTM] Failed to get stored consent:', e);

    return null;
  }
};
